import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPOSheetTabItem,
  IInventoryPOSheetTabsResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const usePOSheetTabsAPI = () => {
  const [sheetTabs, setSheetTabs] = useState<IInventoryPOSheetTabItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response = await axios
        .get(`${INVENTORY_MODULE?.PURCHASE_ORDER_SHEET_TABS?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryPOSheetTabsResponse>) => {
          if (res.data.status === true) {
            setSheetTabs(res.data.data || []);
          } else {
            setSheetTabs([]);
          }
          return res.data;
        })
        .catch((e: AxiosError) => {
          setSheetTabs([]);
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          return null;
        })
        .finally(() => {
          setIsLoading(false);
        });
      return response;
    } catch (error: any) {
      setIsLoading(false);
      setSheetTabs([]);
      if (axios.isAxiosError(error)) {
        captureError(error);
      } else {
        toast.error("Server Error: " + error.message);
      }
      return null;
    }
  }, [dispatch, configuration]);

  return { execute, sheetTabs, isLoading };
};
